import "./fonts.css";
import { LandingPage } from "@/components/landing/landing-page";
import { useAuthSetup } from "@/hooks/useAuthSetup";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { isDesktopApp } from "@/lib/edition/is-desktop";
import { isLocalInstallEdition } from "@/lib/edition/edition";
import { Spinner } from "@/components/ui/spinner";

function HomePage() {
  const { isAuthenticated, isLoading: authLoading } = useAuthSetup();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate({ to: "/dashboard" });
    }
  }, [isAuthenticated, authLoading, navigate]);

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-6 text-primary" />
      </div>
    );
  }

  if (isAuthenticated) {
    return null;
  }

  return <LandingPage />;
}

export const Route = createFileRoute("/_home/")({
  // Ni la build de Tauri (desktop) ni on-prem muestran la landing de marketing.
  // Redirigimos a sign-in, que a su vez bouncea a usuarios autenticados a su
  // dashboard, o al /setup si es el primer arranque on-prem. En web SaaS no aplica.
  beforeLoad: () => {
    if (isDesktopApp() || isLocalInstallEdition()) {
      throw redirect({ to: "/auth/sign-in" });
    }
  },
  component: HomePage,
});
